export const activity = {
  activityWebEmptyStateTitle: 'Жодного сповіщення',
  activityWebEmptyStateText: 'У майбутньому тут будуть твої сповіщення',
  activitySeeAll: 'Дивитись усі',
  in: 'у'
}
